export default [
  {
    path: "/ferramentas",
    name: "tools",
    component: () => import("../views/tools/Index.vue"),
    meta: {
      template: () => import("../templates/Base.vue"),
      viewContainer: true,
      protected: true,
      breadcrumbs: ["tools"]
    }
  },

  // MINHA CONTA
  {
    path: "/ferramentas/coproducoes",
    name: "tools-coproductions",
    component: () => import("../views/tools/account/CoProducers.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["tools", "tools-coproductions"]
    }
  },
  {
    path: "/ferramentas/central-de-colaboradores",
    name: "tools-partners",
    component: () => import("../views/tools/account/PartnersCenter.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["central-de-colaboradores"],
      viewContainer: true
    }
  },

  // INTEGRAÇÕES
  {
    path: "/ferramentas/webhook",
    name: "tools-webhook",
    component: () => import("../views/tools/integrations/Webhook.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["webhook-api-e-notificacoes"],
      viewContainer: true,
      breadcrumbs: ["tools", "tools-webhook"]
    }
  },

  {
    path: "/ferramentas/leadlist",
    name: "tools-leadlist",
    component: () => import("../views/tools/integrations/LeadList.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["lead-list"],
      viewContainer: true
    }
  },

  // EMAIL MARKETING
  {
    path: "/ferramentas/email-marketing",
    name: "tools-email-marketing",
    component: () => import("../views/tools/integrations/EmailMarketing.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["e-mail-marketing"],
      breadcrumbs: ["tools", "tools-email-marketing"]
    }
  },
  {
    path: "/ferramentas/email-marketing/active-campaign",
    name: "tools-active-campaign",
    component: () =>
      import("../views/tools/integrations/EmailMarketing/ActiveCampaign.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["e-mail-marketing"]
    }
  },
  {
    path: "/ferramentas/email-marketing/leadlovers",
    name: "tools-leadlovers",
    component: () =>
      import("../views/tools/integrations/EmailMarketing/LeadLovers.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["e-mail-marketing"]
    }
  },
  {
    path: "/ferramentas/email-marketing/rdstation",
    name: "tools-rd-station-marketing",
    component: () =>
      import("../views/tools/integrations/EmailMarketing/RdStation.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["e-mail-marketing"]
    }
  },

  // AUTOMAÇÕES
  {
    path: "/ferramentas/automacoes",
    name: "tools-automations",
    component: () =>
      import("../views/tools/integrations/Automations/Automations.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["automacoes"],
      breadcrumbs: ["tools", "tools-automations"]
    }
  },
  {
    path: "/ferramentas/automacoes/voxuy",
    name: "tools-voxuy",
    component: () =>
      import("../views/tools/integrations/Automations/Voxuy.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/hotzapp",
    name: "tools-hotzapp",
    component: () =>
      import("../views/tools/integrations/Automations/Hotzapp.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/telegram",
    name: "tools-telegram",
    component: () =>
      import("../views/tools/integrations/Automations/Telegram.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/make",
    name: "tools-make",
    component: () => import("../views/tools/integrations/Automations/Make.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/zapier",
    name: "tools-zapier",
    component: () =>
      import("../views/tools/integrations/Automations/Zapier.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  // {
  //   path: "/ferramentas/automacoes/notificacoes-inteligentes",
  //   name: "tools-notificacoes-inteligentes",
  //   component: () =>
  //     import("../views/tools/integrations/Automations/SmartNotifications.vue"),
  //   meta: {
  //     template: () => import("../templates/Default.vue"),
  //     protected: true,
  //     permissions: ["automacoes"]
  //   }
  // },
  {
    path: "/ferramentas/automacoes/clicksign",
    name: "tools-clicksign",
    component: () =>
      import("../views/tools/integrations/Automations/Clicksign.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/funnel-control",
    name: "tools-funnel-control",
    component: () =>
      import("../views/tools/integrations/Automations/FunnelControl.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["automacoes"]
    }
  },
  {
    path: "/ferramentas/automacoes/digitalmanagerguru",
    name: "tools-digital-manager-guru",
    component: () =>
      import("../views/tools/integrations/Automations/DigitalManagerGuru.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true
    }
  },

  // NOTAS FISCAIS
  {
    path: "/ferramentas/notas-fiscais",
    name: "tools-invoices",
    component: () => import("../views/tools/integrations/Invoices.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["notas-fiscais"],
      breadcrumbs: ["tools", "tools-invoices"]
    }
  },
  {
    path: "/ferramentas/notas-fiscais/detalhes",
    name: "tools-invoices-details",
    component: () =>
      import("../views/tools/integrations/Invoices/Invoices.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["notas-fiscais"],
      viewContainer: true
    }
  },
  {
    path: "/ferramentas/notas-fiscais/enotas",
    name: "tools-enotas",
    component: () => import("../views/tools/integrations/Invoices/ENotas.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["notas-fiscais"]
    }
  },
  {
    path: "/ferramentas/notas-fiscais/bling",
    name: "tools-bling",
    component: () => import("../views/tools/integrations/Invoices/Bling.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["notas-fiscais"]
    }
  },
  {
    path: "/ferramentas/notas-fiscais/notazz",
    name: "tools-notazz",
    component: () => import("../views/tools/integrations/Invoices/Notazz.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["notas-fiscais"]
    }
  },
  {
    path: "/ferramentas/notas-fiscais/spedy",
    name: "tools-spedy",
    component: () => import("../views/tools/integrations/Invoices/Spedy.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["notas-fiscais"]
    }
  },

  // ÁREA DE MEMBROS
  {
    path: "/ferramentas/area-de-membros",
    name: "tools-member-area",
    component: () => import("../views/tools/integrations/MemberArea.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"],
      breadcrumbs: ["tools", "tools-member-area"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/kajabi",
    name: "tools-kajabi",
    component: () =>
      import("../views/tools/integrations/MemberArea/Kajabi.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/memberkit",
    name: "tools-memberkit",
    component: () =>
      import("../views/tools/integrations/MemberArea/Memberkit.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/cademi",
    name: "tools-cademi",
    component: () =>
      import("../views/tools/integrations/MemberArea/Cademi.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/astron-members",
    name: "tools-astron-members",
    component: () =>
      import("../views/tools/integrations/MemberArea/Astron.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/ead",
    name: "tools-ead",
    component: () => import("../views/tools/integrations/MemberArea/Ead.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      viewContainer: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/alpaclass",
    name: "tools-alpaclass",
    component: () =>
      import("../views/tools/integrations/MemberArea/Alpaclass.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },
  {
    path: "/ferramentas/area-de-membros/oce-play",
    name: "tools-oce-play",
    component: () =>
      import("../views/tools/integrations/MemberArea/OcePlay.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["kajabi"]
    }
  },

  {
    path: "/ferramentas/zoom",
    name: "tools-zoom",
    component: () => import("../views/tools/integrations/Zoom.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["zoom"]
    }
  },

  // CERTIFICAÇÕES MEC
  {
    path: "/ferramentas/certificacoes-mec",
    name: "tools-mec-certifications",
    component: () =>
      import("../views/tools/integrations/MecCertifications.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["certificacoes-mec"],
      breadcrumbs: ["tools", "tools-mec-certifications"]
    }
  },
  {
    path: "/ferramentas/certificacoes-mec/unifast",
    name: "tools-unifast",
    component: () =>
      import("../views/tools/integrations/MemberArea/Integrat.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      viewContainer: true,
      protected: true,
      permissions: ["certificacoes-mec"]
    }
  },

  // ADS E RASTREAMENTO
  {
    path: "/ferramentas/google-ads",
    name: "tools-google-ads",
    component: () => import("../views/tools/ads/GoogleAds.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["pixel-de-rastreamento"],
      viewContainer: true
    }
  },
  {
    path: "/ferramentas/facebook-ads",
    name: "tools-facebook-ads",
    component: () => import("../views/tools/ads/FacebookAds.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["pixel-de-rastreamento"],
      viewContainer: true
    }
  },
  {
    path: "/ferramentas/google-analytics",
    name: "tools-google-analytics",
    component: () => import("../views/tools/ads/GoogleAnalytics.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["pixel-de-rastreamento"],
      viewContainer: true
    }
  },
  {
    path: "/ferramentas/kwai-ads",
    name: "tools-kwai-ads",
    component: () => import("../views/tools/ads/Kwai.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      permissions: ["pixel-de-rastreamento"],
      viewContainer: true
    }
  }
];
